// import React, { useState, useEffect } from "react";
// import { Button } from "@mui/material";
// import patientService from "../../../Services/patientService";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import medicalServices from "../../../Services/medicalServices";

// const AddEditMedicalService = () => {

//   const getCurrentDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   // 1️⃣ State
//   const [patientData, setPatientData] = useState({   
//     name: "",
//     price: "",
//     discount: "",
//     date: getCurrentDate(),
//     lab_test_id: "1", // default to Medical Services
//   });

//   const { id } = useParams(); 
//   const navigate = useNavigate();

//   // 2️⃣ Fetch data on edit
//   useEffect(() => {
//     if (id) {
//       const fetchPatientData = async () => {
//         try {
//           const response = await patientService.fetchPatientById(id);
//           // Merge state to prevent lab_test_id loss
//           setPatientData(prev => ({ ...prev, ...response.patient }));
//         } catch (error) {
//           toast.error("Error fetching patient data.");
//         }
//       };

//       fetchPatientData();
//     }
//   }, [id]);

//   // 3️⃣ Handle input and dropdown changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setPatientData(prev => ({ ...prev, [name]: value }));
//   };

//   // 4️⃣ Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await medicalServices.update(id, patientData);
//         toast.success("Medical Service updated successfully!");
//       } else {
//         await medicalServices.create(patientData);
//         toast.success("Medical Service added successfully!");
//       }
//       navigate("/account/medicalservices");
//     } catch (error) {
//       toast.error("Error saving patient.");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center text-[#F07F1B] font-[900] text-[30px]">
//         {id ? "Update Medical Service" : "Add Medical Service"}
//       </h1>

//       <div className="grid grid-cols-3 gap-10 my-[20px] mt-20">
//         <div>
//           <label className="font-semibold text-sm">Medical Service</label>
//           <input
//             name="name"
//             value={patientData.name}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         <div>
//           <label className="font-semibold text-sm">Price</label>
//           <input
//             type="number"
//             name="price"
//             value={patientData.price}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         <div>
//           <label className="font-semibold text-sm">Discount</label>
//           <input
//             type="number"
//             name="discount"
//             value={patientData.discount}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         <div>
//           <label className="font-semibold text-sm">Purchase Date</label>
//           <input
//             type="date"
//             name="date"
//             value={patientData.date}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//         {/* <div>
//           <label className="font-semibold text-sm">Category</label>
//           <select
//             name="lab_test_id"
//             value={patientData.lab_test_id}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           >
//             <option value="1">Medical Services</option>
//             <option value="2">Lab Test</option>
//           </select>
//         </div> */}
        
//         <div>
//           <label className="font-semibold text-sm">Purchase price</label>
//           <input
//             type="number"
//             name="purchase_price"
//             value={patientData.purchase_price}
//             onChange={handleChange}
//             required
//             className="w-full bg-gray-50 p-3 text-sm border-b-[3px] rounded-lg focus:outline-none focus:border-[#F07F1B] mt-1"
//           />
//         </div>

//       </div>

//       <div className="text-center my-[30px] mt-10">
//         <button
//           type="submit"
//           className="bg-white text-[#F07F1B] font-semibold shadow-lg border hover:bg-[#F07F1B] hover:text-white py-2 px-8 rounded-full duration-300"
//         >
//           {id ? "Update Data" : "Add Medical Data"}
//         </button>
//       </div>
//     </form>
//   );
// };

// export default AddEditMedicalService;


import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import patientService from "../../../Services/patientService";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import medicalServices from "../../../Services/medicalServices";

// ── Reusable components ──────────────────────────────────────
const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, prefix, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <div className="relative">
      {prefix && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">
          {prefix}
        </span>
      )}
      <input
        {...props}
        className={`w-full ${prefix ? "pl-8" : "px-3"} pr-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-400 focus:ring-2 focus:ring-orange-100`}
      />
    </div>
  </div>
);

const AddEditMedicalService = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [patientData, setPatientData] = useState({
    name: "",
    price: "",
    discount: "",
    date: getCurrentDate(),
    lab_test_id: "1",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchPatientData = async () => {
        try {
          const response = await patientService.fetchPatientById(id);
          setPatientData(prev => ({ ...prev, ...response.patient }));
        } catch (error) {
          toast.error("Error fetching patient data.");
        }
      };
      fetchPatientData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatientData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await medicalServices.update(id, patientData);
        toast.success("Medical Service updated successfully!");
      } else {
        await medicalServices.create(patientData);
        toast.success("Medical Service added successfully!");
      }
      navigate("/account/medicalservices");
    } catch (error) {
      toast.error("Error saving patient.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-10 px-4">
      <div className="w-full max-w-[1400px]">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* ── Header ── */}
          <div className="bg-gray-800 px-8 py-5">
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              {id ? "Update Medical Service" : "Add Medical Service"}
            </h1>
            <p className="text-gray-400 text-[12px] mt-0.5">
              Fill in all fields to register the medical service record
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="px-8 py-6">

              {/* ── Section 1: Basic Info ── */}
              <SectionLabel>Basic Information</SectionLabel>
              <div className="grid grid-cols-2 gap-4">
                <InputField
                  label="Medical Service"
                  type="text"
                  name="name"
                  placeholder="e.g. X-Ray, Ultrasound"
                  value={patientData.name}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Purchase Date"
                  type="date"
                  name="date"
                  value={patientData.date}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* ── Section 2: Pricing ── */}
              <SectionLabel>Pricing</SectionLabel>
              <div className="grid grid-cols-3 gap-4">
                <InputField
                  label="Purchase Price"
                  type="number"
                  name="purchase_price"
                  placeholder="0"
                  prefix="Rs."
                  value={patientData.purchase_price}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Price"
                  type="number"
                  name="price"
                  placeholder="0"
                  prefix="Rs."
                  value={patientData.price}
                  onChange={handleChange}
                  required
                />
                <InputField
                  label="Discount in Percent"
                  type="number"
                  name="discount"
                  placeholder="0"
                  value={patientData.discount}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* ── Footer ── */}
              <div className="border-t border-gray-100 mt-8 pt-6 flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => navigate("/account/medicalservices")}
                  className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
                >
                  ← Cancel
                </button>
                <button
                  type="submit"
                  className="relative overflow-hidden bg-gray-800 text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg border border-gray-300 shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300 before:absolute before:inset-0 before:-translate-x-full hover:before:translate-x-full before:bg-white/20 before:transition-transform before:duration-500"               
                >
                  {id ? "Update Medical Service →" : "Save Medical Service →"}
                </button>
              </div>

            </div>
          </form>
        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4">
          All fields marked as required must be filled before saving.
        </p>
      </div>
    </div>
  );
};

export default AddEditMedicalService;